import React, { useEffect, useCallback } from "react";
import { ErrorCircle24Regular } from "@fluentui/react-icons";
import "./ErrorNotification.css";

interface ErrorNotificationProps {
    title: string;
    message: string;
    onClose: () => void;
}

export const ErrorNotification: React.FC<ErrorNotificationProps> = ({ title, message, onClose }) => {
    const handleKeyDown = useCallback(
        (event: KeyboardEvent) => {
            if (event.key === "Escape") onClose();
        },
        [onClose]
    );

    useEffect(() => {
        document.addEventListener("keydown", handleKeyDown);
        document.body.style.overflow = "hidden";
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.body.style.overflow = "";
        };
    }, [handleKeyDown]);

    return (
        <div
            className="error-notification-backdrop"
            onClick={onClose}
            role="alertdialog"
            aria-modal="true"
            aria-labelledby="error-notification-title"
            aria-describedby="error-notification-message"
        >
            <div className="error-notification-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="error-notification-header">
                    <div className="error-notification-header-left">
                        <div className="error-notification-icon">
                            <ErrorCircle24Regular />
                        </div>
                        <span id="error-notification-title" className="error-notification-title">
                            {title}
                        </span>
                    </div>
                </div>
                <div className="error-notification-body">
                    <p id="error-notification-message" className="error-notification-message">
                        {message}
                    </p>
                </div>
                <div className="error-notification-footer">
                    <button className="error-notification-btn-close" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};
